export const config = {
  auth: {
    authority: "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_0cibqf0jf",
    clientId: "44l45j5a2485epmqpvcvi8a8qc",
    redirectUri: "https://matrixcare-help-chatbot.saas-sltc-sandbox-dev.dht.live",
    postLogoutRedirectUri: "https://matrixcare-help-chatbot.saas-sltc-sandbox-dev.dht.live",
    cognitoDomain: "https://us-west-20cibqf0jf.auth.us-west-2.amazoncognito.com",
  },
  api: {
    ragChatEndpoint: "https://90o9a6to8d.execute-api.us-west-2.amazonaws.com/prod/chat/rag",
    vectorStoreId: "vs_67e6b7b23d308191803ed6e98906b519",
  },
};
